// Е23(в): чете отговора като JSON; ако тялото НЕ е JSON (напр. 500 HTML,
// прокси грешка) → ясно съобщение вместо празна/неясна грешка. Важи за всички
// заявки (вкл. качванията).
const parseResponse = async (response) => {
    let result;
    try {
        result = await response.json();
    } catch (e) {
        throw {message: `Грешка на сървъра (код ${response.status}). Опитайте отново.`};
    }
    if (!response.ok) {
        if (response.status === 401) {
            localStorage.setItem('auth', JSON.stringify({}));
        }
        throw result;
    }
    return result;
};

const requestServer = async (method, url, data) => {
    const options = {};

    if (method !== 'GET') {
        options.method = method;

        if (data) {
            options.headers = {
                'content-type': 'application/json'
            }
            options.body = JSON.stringify(data);
        }
    }

    const serializedAuth = localStorage.getItem('auth');

    if (serializedAuth) {
        const auth = JSON.parse(serializedAuth);

        if (auth.token) {
            options.headers = {
                ...options.headers,
                'Authorization': `Bearer ${auth.token}`
            };
        }
    }

    const response = await fetch(url, options);
    return parseResponse(response);
};

// Multipart качване (напр. PDF за Е10). НЕ задава content-type — браузърът го
// слага с boundary; само добавя Bearer токена.
const requestForm = async (url, formData) => {
    const options = {method: 'POST', body: formData};

    const serializedAuth = localStorage.getItem('auth');
    if (serializedAuth) {
        const auth = JSON.parse(serializedAuth);
        if (auth.token) {
            options.headers = {'Authorization': `Bearer ${auth.token}`};
        }
    }

    const response = await fetch(url, options);
    return parseResponse(response);
};

export const requester = () => {

    return {
        get: requestServer.bind(null, 'GET'),
        post: requestServer.bind(null, 'POST'),
        put: requestServer.bind(null, 'PUT'),
        delete: requestServer.bind(null, 'DELETE'),
        postForm: requestForm
    }
}